import { useNavigate } from 'react-router-dom';
import type { EventItem } from '@/types';
import { materialMeta, statusStyle } from '@/utils/content';

export default function EventCard({ ev }: { ev: EventItem }) {
  const navigate = useNavigate();
  const m = materialMeta[ev.dominantType];
  return (
    <article
      className="group flex flex-col bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-background-300 transition-colors cursor-pointer"
      onClick={() => navigate(`/event/${ev.slug}`)}
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={ev.cover}
          alt={ev.title}
          title={`${ev.title} · 素材档案`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/60 to-transparent"></div>
        <span
          className={`absolute top-3 left-3 inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full ${statusStyle[ev.status]}`}
        >
          <i className="ri-verified-badge-fill"></i>
          {ev.status}
        </span>
        <span className="absolute bottom-3 left-3 inline-flex items-center gap-1.5 text-background-50 text-xs bg-foreground-950/40 backdrop-blur-sm px-2.5 py-1 rounded-full">
          <i className={`${m.icon} text-secondary-300`}></i>
          {m.label}
        </span>
      </div>
      <div className="flex flex-col gap-2 p-4 md:p-5 flex-1">
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded bg-secondary-100 text-secondary-900 whitespace-nowrap">
            {ev.category}
          </span>
          <time className="whitespace-nowrap">{ev.time}</time>
          <span className="ml-auto inline-flex items-center gap-1 text-primary-600 whitespace-nowrap">
            <i className="ri-fire-fill"></i>{ev.heat}
          </span>
        </div>
        <h3 className="font-display font-bold text-foreground-950 leading-snug text-base md:text-lg group-hover:text-primary-600 transition-colors">
          {ev.title}
        </h3>
        <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 flex-1">{ev.tagline}</p>
        <div className="flex items-center gap-2 text-xs text-foreground-500 pt-1">
          <i className="ri-user-line"></i>
          <span className="truncate">{ev.persons.join(' / ')}</span>
        </div>
      </div>
    </article>
  );
}